export default __webpack_public_path__ + "images/DF.27b6cba.png";